module.exports = __webpack_public_path__ + "media/personal_finance/simpletuition-apply-now-107bf991.png";